import { Account } from '@core/model/domain/account';
import { Mapper } from '@core/model/framework/mapper';
import { AccountDto } from '@core/service/digital-factory/account/types/accountDto';
import { injectable } from 'inversify';

@injectable()
export class AccountMapper implements Mapper<Account, AccountDto> {
  toDomain(accountDto: AccountDto) {
    const account: Account = {
      balance: accountDto.balance.toString(),
      currency: accountDto.currency,
      id: accountDto.id,
      iban: accountDto.iban,
      name: accountDto.name,
    };

    return account;
  }
}
